$.formUtils.addValidator({
	name : 'url',
	validatorFunction : function(url, $el) {
		const actualUrl = $el.val();
		const urlFilter = new RegExp('((https?:\\/\\/|www.)([a-z\\d-]+[\\w\\/.?=&%:#+,@!]*[\\w\\/]))', 'img');;
		return actualUrl === "" || urlFilter.test(actualUrl);
	},
	errorMessage : '',
	errorMessageKey: 'badUrl'
});
